import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as inventoryResources} from '../fuseInventoryResourceMap';
import LocationAuditStaticTableRow from '../components/LocationAuditStaticTableRow';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";

/**
 * A component for generating rows of LocationAuditStaticTableRows.
 *
 */
class LocationAuditStaticTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            locationId: '',
            auditList: {},
            noAudits: false,
        };
    }

    componentWillMount() {
        this.setState({
            locationId: this.props.locationId,
        });
        this.fetchLocationAudits();
    }

    // Get all Audits for this Location
    fetchLocationAudits() {
        const params = {
            filter: {
                id: this.props.locationId
            },
            pagination: {page: 1, perPage: 100},
            sort: {field: "audit_uuid", order: "ASC"}
        };
        const resource = inventoryResources.LocationAudits.GET_ONE(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let payload = result.data.payload;
                        let auditList = null;
                        if (payload) {
                            if (!payload.length) {
                                auditList = [payload];
                            } else {
                                auditList = payload;
                            }
                        }
                        for (let audit of auditList) {
                            audit.date = functions.convertDate(audit.start_time);
                        }
                        this.setState({
                            auditList: auditList,
                            noAudits: false
                        });
                    } else {
                        this.setState({
                            noAudits: true
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    // Create table row(s) of Audit item(s) (should be a single item)
    makeLocationAuditStaticTable = (list, id, path, showView) => {
        const styles = {
            row: {height: '35px',},
            column: {height: '35px'},
            columnFirst: {paddingLeft: '36px'},
        };

        if (!list || !list.length) {
            let message = (this.state.noAudits) ? 'No Audits for this Location' : 'Loading';
            return (
                [<TableRow key={`location-audit-empty-${id}`} style={styles.row}>
                    <TableRowColumn
                        colSpan={5}
                        style={{...styles.column, ...styles.columnFirst}}>
                        {message}
                    </TableRowColumn>
                    {showView &&
                    <TableRowColumn style={styles.column}>&nbsp;</TableRowColumn>
                    }
                </TableRow>]
            )
        }
        return (
            list.map((item, index) => (
                <LocationAuditStaticTableRow
                    key={item.audit_uuid + index}
                    data={item}
                    locationAuditPath={path}
                    showView={showView}
                />
            ))
        )
    };

    render() {
        const {
            locationId,
            locationAuditPath,
            showView,
        } = this.props;

        const styles = {
            bg: {backgroundColor: '#f6f6f6'},
            row: {height: '35px',},
            column: {height: '35px'},
            columnFirst: {paddingLeft: '36px'},
            create: {
                backgroundColor: '#f6f6f6',
                textAlign: 'right',
                paddingRight: '36px',
                borderBottom: '1px solid rgb(244,244,244)'
            },
        };

        return (
            <div>
                <Table selectable={false} multiSelectable={false} style={styles.bg}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow style={styles.row}>
                            <TableHeaderColumn
                                colSpan={2}
                                style={{...styles.column, ...styles.columnFirst}}>Audit UUID</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Date</TableHeaderColumn>
                            <TableHeaderColumn style={styles.column}>Type</TableHeaderColumn>
                            {showView &&
                            <TableHeaderColumn style={styles.column}>View</TableHeaderColumn>
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false} style={styles.bg}>
                        {[...this.makeLocationAuditStaticTable(this.state.auditList, locationId, locationAuditPath, showView)]}
                    </TableBody>
                </Table>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            locationId: ownProps.locationId,
            auditList: ownProps.auditList,
            viewType: ownProps.viewType,
        }
    }
    return {}
};

LocationAuditStaticTable.propTypes = {
    addField: PropTypes.bool,
    locationId: PropTypes.string,
    auditList: PropTypes.object,
    locationAuditPath: PropTypes.string,
    viewType: PropTypes.string,
    showView: PropTypes.bool,
};

LocationAuditStaticTable.defaultProps = {
    addField: true,
    locationId: null,
    auditList: {},
    locationAuditPath: '/LocationAudits',
    viewType: 'list',
    showView: false,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(LocationAuditStaticTable);


// WEBPACK FOOTER //
// ./src/Fuse/components/LocationAuditStaticTable.js